import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";


export const useGetDesignerSettings = (designerId: string, t?: number) => {

    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!designerId) return;

        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/Designer/GetDesignerSettings`)
            .addQuery('designerId', designerId)
            .get()
            .release()
            .then((r: any) => {
                setIsLoading(false);
                if (r) {
                    setResp(r)
                }
            }).catch((e: any) => {
            setIsLoading(false);
            setError(true);
        })

    }, [designerId,t]);

    return {
        resp,
        isLoading,
        error
    }
}import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";


export const useGetDesignerSettings = (designerId: string, t?: number) => {

    const [resp, setResp] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!designerId) return;

        setIsLoading(true);
        API.request()
            .endpoint(Endpoints.geograffee)
            .url(`/api/Designer/GetDesignerSettings`)
            .addQuery('designerId', designerId)
            .get()
            .release()
            .then((r: any) => {
                setIsLoading(false);
                if (r) {
                    setResp(r)
                }
            }).catch((e: any) => {
            setIsLoading(false);
            setError(true);
        })

    }, [designerId,t]);

    return {
        resp,
        isLoading,
        error
    }
}